export default "__VITE_ASSET__b9647a38__"